export const TopicUnavailableGraphics = () => (
  <svg
    width="131"
    height="103"
    viewBox="0 0 131 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M125.418 92C129.007 83.8979 131 74.9317 131 65.5C131 29.3253 101.675 0 65.5 0C29.3253 0 0 29.3253 0 65.5C0 74.9317 1.9935 83.8979 5.58215 92H125.418Z"
      fill="url(#paint0_linear_4366_164697)"
    />
    <path
      d="M98.4006 34.9682L98.4006 34.7506L98.0006 34.7507L98.0006 34.3155L98.4006 34.3155L98.4006 34.0979C98.4006 33.671 98.3587 33.2535 98.2788 32.8494L97.8864 32.9271C97.7307 32.14 97.421 31.4082 96.9901 30.7646L97.3225 30.542C96.8554 29.8443 96.2548 29.2438 95.5571 28.7767L95.3345 29.1091C94.6909 28.6782 93.9591 28.3686 93.172 28.2129L93.2497 27.8205C92.8455 27.7405 92.428 27.6987 92.0012 27.6987L90.9703 27.6988L90.9702 28.0988L88.9085 28.0988L88.9086 27.6988L86.8468 27.6989L86.8468 28.0989L84.785 28.099L84.7851 27.699L82.7233 27.6991L82.7233 28.0991L80.6616 28.0991L80.6616 27.6991L78.5999 27.6992L78.5998 28.0992L76.5381 28.0993L76.5381 27.6993L74.4764 27.6993L74.4764 28.0993L72.4146 28.0994L72.4147 27.6994L70.3529 27.6995L70.3529 28.0995L68.2912 28.0996L68.2912 27.6996L66.2295 27.6996L66.2294 28.0996L64.1677 28.0997L64.1677 27.6997L62.106 27.6998L62.106 28.0998L60.0442 28.0999L60.0443 27.6999L57.9825 27.6999L57.9825 28.0999L55.9208 28.1L55.9208 27.7L53.8591 27.7001L53.859 28.1001L51.7973 28.1001L51.7973 27.7001L49.7356 27.7002L49.7356 28.1002L47.6738 28.1003L47.6739 27.7003L45.6121 27.7004L45.6121 28.1004L43.5503 28.1004L43.5504 27.7004L42.5195 27.7005C42.0931 27.7005 41.676 27.7423 41.2722 27.8221L41.3497 28.2145C40.5633 28.3699 39.8321 28.679 39.1888 29.1092L38.9665 28.7766C38.2691 29.2429 37.6685 29.8424 37.2011 30.539L37.5332 30.7619C37.102 31.4045 36.7917 32.1352 36.6349 32.9213L36.2426 32.8431C36.1622 33.2468 36.1197 33.6638 36.1189 34.0902L36.1173 35.0472L36.5173 35.0478L36.514 36.9618L36.114 36.9611L36.1107 38.8751L36.5107 38.8757L36.5073 40.7896L36.1073 40.789L36.104 42.7029L36.504 42.7036L36.5007 44.6175L36.1007 44.6168L36.0974 46.5308L36.4974 46.5314L36.4941 48.4453L36.0941 48.4447L36.0908 50.3586L36.4908 50.3593L36.4875 52.2732L36.0875 52.2725L36.0842 54.1865L36.4842 54.1871L36.4809 56.101L36.0809 56.1004L36.0776 58.0143L36.4776 58.015L36.4743 59.9289L36.0743 59.9282L36.071 61.8422L36.471 61.8428L36.4677 63.7567L36.0677 63.7561L36.066 64.7131C36.0653 65.1404 36.1065 65.5584 36.1859 65.9631L36.5784 65.886C36.7331 66.6742 37.0421 67.4072 37.4728 68.052L37.1402 68.2742C37.607 68.9731 38.2077 69.5749 38.9059 70.0429L39.1286 69.7107C39.7727 70.1425 40.5051 70.4528 41.293 70.6089L41.2153 71.0012C41.6198 71.0814 42.0377 71.1233 42.4651 71.1233L43.4971 71.1233L43.4971 70.7233L45.5611 70.7233L45.561 71.1233L47.625 71.1234L47.625 70.7233L49.689 70.7234L49.6889 71.1234L51.7528 71.1234L51.7529 70.7234L53.8168 70.7234L53.8168 71.1234L55.8807 71.1234L55.8808 70.7234L57.9447 70.7234L57.9447 71.1234L60.0086 71.1235L60.0087 70.7235L62.0726 70.7235L62.0725 71.1235L64.1365 71.1235L64.1365 70.7235L66.2005 70.7235L66.2004 71.1235L68.2644 71.1235L68.2644 70.7235L70.3284 70.7236L70.3283 71.1236L72.3922 71.1236L72.3923 70.7236L74.4562 70.7236L74.4562 71.1236L76.5201 71.1236L76.5202 70.7236L78.5841 70.7236L78.5841 71.1236L80.648 71.1237L80.6481 70.7237L82.712 70.7237L82.7119 71.1237L84.7759 71.1237L84.7759 70.7237L86.8399 70.7237L86.8398 71.1237L88.9038 71.1237L88.9038 70.7237L90.9677 70.7238L90.9677 71.1238L91.9997 71.1238C92.4266 71.1238 92.8442 71.0819 93.2484 71.002L93.1708 70.6096C93.9581 70.4538 94.69 70.1441 95.3338 69.713L95.5563 70.0454C96.2542 69.5782 96.8549 68.9774 97.3221 68.2796L96.9898 68.0571C97.4208 67.4133 97.7306 66.6814 97.8863 65.8941L98.2787 65.9717C98.3587 65.5675 98.4006 65.1499 98.4006 64.723L98.4006 63.6603L98.0006 63.6603L98.0006 61.535L98.4006 61.5349L98.4006 59.4096L98.0006 59.4097L98.0006 57.2843L98.4006 57.2843L98.4006 55.1589L98.0006 55.159L98.0006 53.0336L98.4006 53.0336L98.4006 50.9083L98.0006 50.9083L98.0006 48.783L98.4006 48.7829L98.4006 46.6576L98.0006 46.6576L98.0006 44.5323L98.4006 44.5322L98.4006 42.4069L98.0006 42.4069L98.0006 40.2816L98.4006 40.2816L98.4006 38.1562L98.0006 38.1563L98.0006 36.0309L98.4006 36.0309L98.4006 34.9682Z"
      fill="#F7F8F8"
      stroke="#D1D5DB"
      strokeWidth="0.8"
      strokeDasharray="2 2"
    />
    <g filter="url(#filter0_dd_4366_164697)">
      <rect x="28" y="36.9736" width="63" height="46.0019" rx="8.34289" fill="white" />
      <rect
        x="28.4"
        y="37.3736"
        width="62.2"
        height="45.2019"
        rx="7.94289"
        stroke="#E5E7EB"
        strokeWidth="0.8"
      />
    </g>
    <path
      d="M28.4 41.7874C28.4 39.3487 30.377 37.3717 32.8157 37.3717H86C88.5405 37.3717 90.6 39.4312 90.6 41.9717V46.5781H28.4V41.7874Z"
      fill="white"
      stroke="#DDE2E9"
      strokeWidth="0.8"
    />
    <circle cx="74.5341" cy="42.4765" r="1.37593" fill="#4B5563" />
    <circle cx="79.3505" cy="42.4765" r="1.37593" fill="#4B5563" />
    <circle cx="84.165" cy="42.4765" r="1.37593" fill="#4B5563" />
    <path
      d="M102.001 80C101.5 92 92 90.5 87.0001 89.5C82.0295 89.5 84.0011 90 84.0008 83C83.5008 78 84.0008 72 93.001 71C97.9715 71 102.001 75.0294 102.001 80Z"
      fill="url(#paint1_linear_4366_164697)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84.4969 85.7623C83.7061 84.354 83.25 82.7312 83.25 81C83.25 75.6147 87.6147 71.25 93 71.25C98.3852 71.25 102.75 75.6147 102.75 81C102.75 86.3852 98.3852 90.75 93 90.75C91.2688 90.75 89.646 90.2939 88.2377 89.5031L83.25 90.75L84.4969 85.7623Z"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.8299 78.1699L90.1699 83.8299"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.66 83.66L90 78"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.9 55C40.4029 55 40 55.4029 40 55.9C40 56.3971 40.4029 56.8 40.9 56.8H78.1C78.5971 56.8 79 56.3971 79 55.9C79 55.4029 78.5971 55 78.1 55H40.9ZM40 62.6998C40 62.2027 40.4029 61.7998 40.9 61.7998H78.1C78.5971 61.7998 79 62.2027 79 62.6998C79 63.1969 78.5971 63.5998 78.1 63.5998H40.9C40.4029 63.5998 40 63.1969 40 62.6998ZM40 69.4996C40 69.0026 40.4029 68.5996 40.9 68.5996H67.18C67.6771 68.5996 68.08 69.0026 68.08 69.4996C68.08 69.9967 67.6771 70.3996 67.18 70.3996H40.9C40.4029 70.3996 40 69.9967 40 69.4996Z"
      fill="#D1D5DB"
    />
    <defs>
      <filter
        id="filter0_dd_4366_164697"
        x="17.7104"
        y="35.166"
        width="83.5791"
        height="67.8325"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.39048" />
        <feGaussianBlur stdDeviation="1.59905" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.587207 0 0 0 0 0.587207 0 0 0 0 0.587207 0 0 0 0.14 0"
        />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_4366_164697" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="9.73337" />
        <feGaussianBlur stdDeviation="5.14478" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.972255 0 0 0 0 0.9646 0 0 0 0 0.991618 0 0 0 0.5 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_4366_164697"
          result="effect2_dropShadow_4366_164697"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_4366_164697"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4366_164697"
        x1="68"
        y1="-67.5"
        x2="69.9323"
        y2="144.789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.4" stopColor="#EFEFEF" />
        <stop offset="0.714773" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4366_164697"
        x1="88"
        y1="72"
        x2="97"
        y2="89.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.333659" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
    </defs>
  </svg>
);
